import React from "react";
import { DesktopMainMenu, MenuLink , Containers} from "../styles";
const DesktopMenu = (props) => {
  return (
    <DesktopMainMenu >
      <Containers maxWidth="xl">
      <MenuLink href="/" p="0px">
        <img src="./Image/Logo.png" alt="Logo" style={{width:"55px"}}/>
      </MenuLink>
      <div style={{display:"flex",alignItems:"center"}}>
        {props.menuList.map((value, i) => <MenuLink key={i} onClick={value.onClick} href={value.link} target={value.target} className={value.customClass}> <span /><span /><span /><span />{value.title}</MenuLink>)}
      </div>
          </Containers>
    </DesktopMainMenu>
  );
};

export default DesktopMenu;
